import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {ErrorHandlers} from '@application/helper/error-handlers';
import {NavigationHelperService} from '@application/helper/navigation-helper/navigation-helper.service';
import {RouteUtils} from '@application/helper/routing/route-utils';
import {ColorSet} from '@domain/textile-data/color-set/color-set';
import {ColorSets, COLOR_SETS} from '@infrastructure/http/color-set/color-sets';
import {AssertionUtils, BaseComponent, ObjectUtils} from '@vdw/angular-component-library';
import {isEqual, isNil, isUndefined} from 'lodash-es';
import {takeUntil} from 'rxjs/operators';
import {NavigationAddMaterialSetPageData} from '../../material-set/add/navigation-add-material-set-page-data.type';
import {NavigationMaterialSetData} from '../../material-set/add/navigation-material-set-data.interface';

@Component({
  templateUrl: './add-color-set-page.component.html'
})
export class AddColorSetPageComponent extends BaseComponent implements OnInit {
  public static urlToColorSetOverview = RouteUtils.paths.texStyle.colorSet.absolutePath;
  public static urlToEditColorSet = RouteUtils.paths.texStyle.colorSet.editColorSet.path;
  public static urlToDuplicateColorSet = RouteUtils.paths.texStyle.colorSet.duplicateColorSet.path;

  public colorSetToSave: ColorSet;
  public hasColorSetState = false;

  private urlParams: Params;

  public constructor(
    @Inject(COLOR_SETS) public readonly colorSets: ColorSets,
    private readonly activatedRoute: ActivatedRoute,
    private readonly navigationHelperService: NavigationHelperService<NavigationAddMaterialSetPageData>,
    private readonly router: Router
  ) {
    super();
  }

  public ngOnInit(): void {
    this.urlParams = this.activatedRoute.snapshot.params;
    this.initialiseAddColorSetPage();
  }

  private initialiseAddColorSetPage(): void {
    const emptyColorSetState = {materialSet: null} as NavigationMaterialSetData;
    const colorSetState = this.navigationHelperService.getPartialState<NavigationMaterialSetData>(Object.keys(emptyColorSetState));

    if (!AssertionUtils.isNullOrUndefined(colorSetState) && !ObjectUtils.isDeepEqual(colorSetState, emptyColorSetState)) {
      this.colorSetToSave = colorSetState.materialSet as ColorSet;
      this.hasColorSetState = true;
    } else if (this.isDuplicatingColorSet() || this.isEditingColorSet()) {
      this.colorSets
        .getById(Number(this.urlParams.id))
        .pipe(takeUntil(this.unSubscribeOnViewDestroy))
        .subscribe({
          next: (colorSet: ColorSet) => (this.colorSetToSave = colorSet),
          error: ErrorHandlers.navigateToOverviewAndThrowError(this.router, AddColorSetPageComponent.urlToColorSetOverview)
        });
    } else {
      this.colorSetToSave = ColorSet.createEmptyColorSet();
    }
  }

  private isEditingColorSet(): boolean {
    return !isNil(this.activatedRoute.snapshot.routeConfig) && isEqual(this.activatedRoute.snapshot.routeConfig.path, AddColorSetPageComponent.urlToEditColorSet) && !isUndefined(this.urlParams.id);
  }

  private isDuplicatingColorSet(): boolean {
    return (
      !isNil(this.activatedRoute.snapshot.routeConfig) && isEqual(this.activatedRoute.snapshot.routeConfig.path, AddColorSetPageComponent.urlToDuplicateColorSet) && !isUndefined(this.urlParams.id)
    );
  }
}
